module.exports = __webpack_public_path__ + "static/media/Artboard22.7f380e0c.png";